import React, {Fragment} from 'react';
import './AutocompleteList.less';
import {AutocompleteItem} from "elements/autocomplete-item/AutocompleteItem";
import {ListSplitter} from "elements/list-splitter/ListSplitter.tsx";

export const AutocompleteList = ({options, onOptionClick}) => {
	return <ul className="autocomplete-list">
		{
			options.map((option, index) => <Fragment key={option.id}>
				{index > 0 && <ListSplitter isAlignByContainer/>}
				<li className="autocomplete-list__item" onClick={() => onOptionClick(option.id)}>
					<AutocompleteItem text={option.name}/>
				</li>
			</Fragment>)
		}
	</ul>
}
